import { useQuery } from "@tanstack/react-query";
import React, { useEffect, useState, useMemo } from "react";
import { useForm } from "react-hook-form";
import {
  getCategories,
  getOfferFavorites,
  getOffers,
  getStates,
} from "../../api";
import ContactModal from "../../components/contact_modal";
import FillterModal from "../../components/fillter_modal";
import ItemCard from "../../components/item";
import LgSearch from "../../components/Lg_search";
import SmallSearch from "../../components/small_search";
import { cities_data, markets_data } from "../../data";
import { useAuth } from "../../store/authProvider";
import Client from "../../utils/client";
import ShowModal from "../../components/show_modal";
import { motion, AnimatePresence } from "framer-motion";
import notFound from "../../images/not-found.png";
import ReactGA from "react-ga4";
import { Helmet } from "react-helmet";
import Skelton from "../../icons/skelton";
import PlaceOrderModal from "../../components/place_order_modal";

const Buy = () => {
  ReactGA.send({
    hitType: "pageview",
    page: window.location.pathname,
    title: "Crops Offers",
  });

  const { isAuth } = useAuth();
  const [showContactModal, setShowContactModal] = useState(false);
  const [showOrderModal, setShowOrderModal] = useState(false);
  const [showFilters, setShowFilters] = useState(false);
  const [data, setData] = useState([]);
  const [page, setPage] = useState(1);

  const [priceSort, setPriceSort] = useState(null);

  const { data: categories } = useQuery({
    queryKey: ["categories"],
    queryFn: () => getCategories(),
    initialData: [],
  });

  const { data: states } = useQuery({
    queryKey: ["states"],
    queryFn: () => getStates(),
    initialData: [],
  });

  const {
    data: offers,
    isFetching,
    refetch,
  } = useQuery({
    queryKey: ["offers", priceSort],
    queryFn: () =>
      getOffers(
        "sell",
        state.map((e) => e.value),
        crop.map((e) => e.value),
        getValues().search_word === ""
          ? getValues().search_words
          : getValues().search_word,
        page,
        priceSort
      ),
    // onSuccess: (res) => setData([...new Set([...data, ...res.data])]),
    onSuccess: (res) => setData([...new Set([...res.data])]),
    refetchOnWindowFocus: false,
    initialData: [],
  });

  const [crop, setCrop] = useState([]);
  const [state, setState] = useState([]);
  const {
    register,
    handleSubmit,
    formState: { errors },
    getValues,
  } = useForm();
  const [showModal, setShowModal] = useState(false);
  const [offer, setOffer] = useState();

  const getOffer = async (id) => {
    const response = await Client.get(`/offer/${id}`).then((res) => res.data);
    setOffer(response);
    setShowModal(true);
    const user_id = localStorage.getItem("user_id");
    await Client.post("/admin/logs", {
      user_id: isAuth ? user_id : null,
      action: "Product View",
      product_type: "Crops Product",
      product_id: id.toString(),
    });
  };

  const onSubmit = () => {
    refetch();
  };

  const { data: offersFavorites } = useQuery({
    queryKey: ["favorites"],
    queryFn: () => getOfferFavorites(),
    initialData: [],
    enabled: isAuth,
  });

  const handlePage = () => {
    setPage((prev) => prev + 1);
  };

  useEffect(() => {
    refetch();
  }, [page]);

  return (
    <>
      <Helmet>
        <title>عروض المحاصيل - محصول</title>
        <meta property="og:site_name" content="Mahsool" />
        <meta name="keywords" content="Mahsool" />
        <meta property="og:title" content="عروض المحاصيل - محصول" />
        <meta property="og:description" content="mahsool" />
        <meta property="og:locale" content="en_US" />
        <meta property="og:type" content="website" />
      </Helmet>

      <AnimatePresence>
        {showFilters && (
          <FillterModal
            categories={categories}
            crop={crop}
            onSubmit={refetch}
            setCrop={setCrop}
            setShowFilters={setShowFilters}
            states={states}
            setState={setState}
            state={state}
            name="المحصول"
          />
        )}
        {showModal && (
          <ShowModal
            offer={offer}
            cities_data={cities_data}
            markets_data={markets_data}
            setShowContactModal={setShowContactModal}
            setShowOrderModal={setShowOrderModal}
            setShowModal={setShowModal}
            states={states}
            favoriteOffers={offersFavorites}
            type="متوفر"
            offertype="sell"
          />
        )}
      </AnimatePresence>

      {showContactModal && (
        <ContactModal offer={offer} setShowContactModal={setShowContactModal} />
      )}
      {showOrderModal && (
        <PlaceOrderModal
          item={offer}
          setShowOrderModal={setShowOrderModal}
          tradeType={"Demand"}
          negotiationType={"Crop"}
        />
      )}
      <div className="grid w-11/12 grid-cols-2 gap-5 mt-10 lg:w-[81rem] lg:gap-2 lg:grid-flow-row lg:grid-cols-5 mx-6 lg:mx-0 lg:px-20">
        <SmallSearch
          page={0}
          onSubmit={handleSubmit(onSubmit)}
          register={register}
          categories={categories}
          states={states}
          crop={crop}
          state={state}
          setState={setState}
          setCrop={setCrop}
          setShowFilters={setShowFilters}
          text="إضافة عرض"
          priceSort={priceSort}
          setPriceSort={setPriceSort}
          setPage={setPage}
        />

        <LgSearch
          page={0}
          onSubmit={handleSubmit(onSubmit)}
          register={register}
          setShowFilters={setShowFilters}
          text="إضافة عرض"
          priceSort={priceSort}
          setPriceSort={setPriceSort}
          setPage={setPage}
        />


        {data.length === 0 ? (
          <div className="flex flex-col col-span-2 mt-20 justify-center text-center lg:col-span-5">
            <div className="font-bold mx-auto">
              <img src={notFound} alt="Not Found" />
            </div>
            <div className="h-6"></div>
            <div className="flex items-center mx-auto justify-center h-12 text-lg font-bold ">
              عذراً لا توجد محاصيل
            </div>
          </div>
        ) : (
          data.map((item) => (
            <ItemCard
              key={item.id}
              item={item}
              getOffer={getOffer}
              editLink={`/editform/${item.id}`}
              favoriteOffers={offersFavorites}
            />
          ))
        )}

        {isFetching && [...Array(7).keys()].map((_, i) => <Skelton key={i} />)}
      </div>

      <div className="text-center">
        {!isFetching && offers.pageCount > offers.page && (
          <button
            onClick={handlePage}
            disabled={offers.pageCount < offers.page || isFetching}
            className="bg-primary mt-8 text-white rounded-full py-1 px-4 hover:bg-[#42cf6a] hover:scale-105 transition disabled:opacity-50 disabled:animate-pulse"
          >
            عرض المزيد
          </button>
        )}
      </div>
    </>
  );
};

export default Buy;
